import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import _ from 'lodash';
import { isAndroid, isMobile as nativeMobile } from 'react-device-detect';
import { format } from '@breezeway/brzw-react-core';
import { forms as Forms } from '@breezeway/brzw-components';
import { contact } from '../../../../utils';
import ModalSelect from '../../../modal_select';

import './form-array-phone-field-control.scss';

const { NUMBER_TYPES, NUMBER_TYPE_OPTIONS } = contact;

const getCountryOptions = options =>
  _.map(options, option => ({
    ...option,
    label: `${_.get(option, 'name')} (+${_.get(option, 'dialCode')})`,
  }));

class FormArrayPhoneFieldControl extends PureComponent {
  constructor(props) {
    super(props);

    this.nativeSelect = React.createRef();
    this.phoneSelect = React.createRef();

    this.state = {
      countryModalOpen: false,
      typeModalOpen: false,
    };

    this.onCountrySelect = this.onCountrySelect.bind(this);
    this.onNativeTypeChange = this.onNativeTypeChange.bind(this);
    this.onTypeClick = this.onTypeClick.bind(this);
    this.onTypeSelect = this.onTypeSelect.bind(this);
    this.toggleCountryModal = this.toggleCountryModal.bind(this);
    this.toggleTypeModal = this.toggleTypeModal.bind(this);
  }

  onTypeClick() {
    if (isAndroid) {
      this.toggleTypeModal();
    } else {
      this.focusNativeSelect();
    }
  }

  onCountrySelect(option) {
    const { countriesOptions } = this.phoneSelect.current;
    const countryIndex = _.findIndex(countriesOptions, { value: option.value });
    this.phoneSelect.current.onCountryIndexChanged(countryIndex);
  }

  onTypeSelect(option) {
    const { numberTypeOptions } = this.phoneSelect.current;
    const typeIndex = _.findIndex(numberTypeOptions, { value: option.value });
    this.phoneSelect.current.onNumberTypeIndexChanged(typeIndex);
  }

  onNativeTypeChange(e) {
    this.onTypeSelect({ value: e.target.value });
  }

  toggleTypeModal() {
    this.setState(prevState => ({
      typeModalOpen: !prevState.typeModalOpen,
    }));
  }

  toggleCountryModal() {
    this.setState(prevState => ({
      countryModalOpen: !prevState.countryModalOpen,
    }));
  }

  focusNativeSelect() {
    this.nativeSelect.current.focus();
  }

  render() {
    const {
      children,
      defaultCountry,
      id,
      label,
      names,
      placeholder,
      preferredCountries,
      required,
    } = this.props;
    const { typeModalOpen, countryModalOpen } = this.state;

    const countryCodeInput = _.get(this.props, `${names[0]}.input`);
    const countryDialCodeInput = _.get(this.props, `${names[1]}.input`);
    const phoneNumberInput = _.get(this.props, `${names[2]}.input`);
    const phoneNumberType = _.get(this.props, `${names[3]}.input`);

    const typeValue = _.get(
      phoneNumberType,
      'value.code',
      _.get(phoneNumberType, 'value', NUMBER_TYPES.MOBILE),
    );

    const numberTypeOptions = _.get(this.phoneSelect, 'current.numberTypeOptions', []);
    const countriesOptions = _.get(this.phoneSelect, 'current.countriesOptions', []);

    return (
      <div className="form-group-row">
        {label && (
          <Label for={id} className="form-group-row__label">
            {required ? (
              <span>
                {label} <span className="text-orange">*</span>
              </span>
            ) : (
              label
            )}
          </Label>
        )}
        <div className="form-group-row__col">
          <Forms.PhoneSelect
            isRequired={required}
            id={id}
            onChange={({ value, iso2, dialCode, type }) => {
              countryCodeInput.onChange(iso2);
              phoneNumberInput.onChange(format.phone.cleanNumber(value, dialCode));
              countryDialCodeInput.onChange(dialCode);
              phoneNumberType.onChange(type);
            }}
            countryValue={defaultCountry || countryCodeInput.value}
            phoneValue={phoneNumberInput.value}
            placeholderText={placeholder}
            preferredCountries={preferredCountries}
            typeValue={typeValue}
            onCountryClick={this.toggleCountryModal}
            onTypeClick={this.onTypeClick}
            isMobile={nativeMobile}
            ref={this.phoneSelect}
          />
          {children}
        </div>

        {nativeMobile && !isAndroid && (
          <div className="form-array-phone-field-control__native-select-wrapper">
            <select
              className="form-array-phone-field-control__native-select"
              ref={this.nativeSelect}
              onChange={this.onNativeTypeChange}
              defaultValue={typeValue}
            >
              {_.map(NUMBER_TYPE_OPTIONS, option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        )}
        {typeModalOpen && (
          <ModalSelect
            full
            onClose={this.toggleTypeModal}
            onSelect={this.onTypeSelect}
            options={numberTypeOptions}
            secondaryText={null}
            title="Select type"
            wrapClassName="style-guide"
          />
        )}
        {countryModalOpen && (
          <ModalSelect
            full
            onClose={this.toggleCountryModal}
            onSelect={this.onCountrySelect}
            options={getCountryOptions(countriesOptions)}
            secondaryText={null}
            title="Select country"
            wrapClassName="style-guide"
          />
        )}
      </div>
    );
  }
}

FormArrayPhoneFieldControl.propTypes = {
  children: PropTypes.node,
  defaultCountry: PropTypes.string,
  id: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  meta: PropTypes.shape({}),
  names: PropTypes.arrayOf(PropTypes.string),
  placeholder: PropTypes.string,
  preferredCountries: PropTypes.arrayOf(PropTypes.string),
  required: PropTypes.bool,
};

FormArrayPhoneFieldControl.defaultProps = {
  defaultCountry: null,
  required: false,
};

export default FormArrayPhoneFieldControl;
